import React from 'react';
import { withRouter } from 'react-router-dom';
import ReactGA from 'react-ga';

class RouteChangeTracker extends React.Component {

  componentDidUpdate(prevProps) {
    const { location, history } = this.props;
    
    // Vérifie si l'URL a changé
    if (location.pathname !== prevProps.location.pathname) {
      if (history.action === 'PUSH') {
        const url = location.pathname + location.search;
        ReactGA.set({ page: url });
        ReactGA.pageview(url); // Enregistre la nouvelle page vue dans Google Analytics
      }
    }
  }

  render() {
    return null; // Ce composant n'a pas de rendu visuel
  }
}

export default withRouter(RouteChangeTracker);
